import { useCurrencyNumberFormatter } from 'hooks';
import { IDashboardChartPayloadType } from '../types/types';
import { Duration } from 'luxon';
import { useCallback } from 'react';

export default function useChartTooltipValueFormatter(valueType: IDashboardChartPayloadType) {
  const formatter = useCurrencyNumberFormatter(null);

  return useCallback(
    (tickItem: number) => {
      if (valueType === 'currency') {
        if (formatter) {
          return formatter.format(tickItem);
        } else {
          return '0';
        }
      } else if (valueType === 'hour') {
        // Reason for timesing hours into seconds is better rounding with luxon
        return Duration.fromObject({ seconds: tickItem * 3600 }).toFormat('h:mm');
      } else {
        return tickItem.toString();
      }
    },
    [formatter, valueType]
  );
}
